<template>
  <div :class="classContainer">
    <div :class="classBackground">
      <div class="ContainerTitle_PConfirm">
        <div class="icon_PConfirm">
          <PIcon :icon="icon" size="130"></PIcon>
        </div>
        <div class="title_PConfirm">
          <slot name="title"></slot>
        </div>
      </div>
      <div class="containerContent_PConfirm">
        <div class="description_PConfirm">
          <slot name="description"></slot>
        </div>
        <div class="content_PConfirm">
          <slot name="content"></slot>
        </div>
        <div class="buttons_PConfirm">
          <PButton @click="cancel" variant="secondary">{{ textButtonCancel }}</PButton>
          <PButton @click="accept">{{ textButtonAccept }}</PButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: {
    PIcon,
  },
})
export class PConfirm extends Vue {
  @Prop({ required: false, default: "div" }) type!: "modal" | "div";
  @Prop({ required: false, default: "IconAlerta" }) icon!: string;
  @Prop({ required: false, default: "Aceptar" }) textButtonAccept!: string;
  @Prop({ required: false, default: "Cancelar" }) textButtonCancel!: string;
  get classContainer(): string {
    if (this.type === "modal") {
      return "container_PConfirm";
    } else {
      return "wrapping_PConfirm";
    }
  }
  get classBackground(): string {
    if (this.type === "modal") {
      return "background_PConfirm";
    } else {
      return "";
    }
  }
  cancel(): void {
    this.$emit("cancel");
  }
  accept(): void {
    this.$emit("accept");
  }
}
export default PConfirm;
</script>
<style lang="scss" scoped>
.container_PConfirm {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.wrapping_PConfirm {
  margin-top: -0.5rem;
}
.background_PConfirm {
  background-color: #fff;
  min-width: 50%;
  box-shadow: 0 10px 20px 0 rgba(227, 227, 227, 0.5);
  border-radius: 6px;
  border: solid 1px #ffd102;
}
.ContainerTitle_PConfirm {
  padding: 2rem;
  background-color: #ffd102;
  min-height: 264px;
}
.title_PConfirm {
  text-align: center;
}
.icon_PConfirm {
  text-align: center;
  padding-bottom: 3rem;
}
.containerContent_PConfirm {
  padding: 3rem;
}
.description_PConfirm {
  margin: 0 auto;
  max-width: 300px;
  text-align: center;
  padding-bottom: 2rem;
}
.content_PConfirm {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.buttons_PConfirm {
  padding-top: 2em;
  display: flex;
  justify-content: center;

  .secondary_PButton,
  .primary_PButton {
    margin: 0 2em;
  }
}
</style>
